/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// USER : MESSAGES STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	usermessage: {
		fontSize: hasRewardsComponent => hasRewardsComponent ? '80%' : '100%',
		display: 'table',
		width: '100%',
		'& .rewardsfeedback, .shareset': {
			display: 'table-cell',
			verticalAlign: 'middle'
		},
		'& .rewardsfeedback': {
			textAlign: 'left'
		},
		'& .shareset': {
			textAlign: 'right'
		}
	}
};